import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { I18nProvider } from './lib/i18n';
import { Home } from './pages/Home';
import { Toaster } from 'sonner';
export function App() {
  return <I18nProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <div className="min-h-screen bg-background text-gray-300 font-sans selection:bg-violet-deep selection:text-white relative" data-id="element-2">
          <div className="bg-grain" data-id="element-3" />
          <Routes data-id="element-4">
            <Route path="/" element={<Home data-id="element-6" />} data-id="element-5" />
          </Routes>
          <Toaster theme="dark" position="bottom-right" toastOptions={{
          style: {
            background: '#0A0C14',
            border: '1px solid rgba(255,255,255,0.1)',
            color: '#fff'
          }
        }} data-id="element-7" />
        </div>
      </BrowserRouter>
    </I18nProvider>;
}